import {useAppSelector} from "hooks/useAppSelector";

const useLiveChat = () => {
    const email = useAppSelector((state) => state.user.user?.email);
    const mobile = useAppSelector((state) => state.user.user?.mobile);
    const userId = useAppSelector((state) => state.user.user?.userId);

    const showLiveChat = () => {
        window.fcWidget?.user.setFirstName(userId || "");
        window.fcWidget?.user.setEmail(email || "");
        window.fcWidget?.user.setPhone(mobile || "");
        window.fcWidget?.setExternalId(userId || "");
        window.fcWidget?.show();
        window.fcWidget?.open();
    };

    return {showLiveChat};
};

export default useLiveChat;
